import { useSuspenseQuery } from '@apollo/client';

import type { SeoLinkBoxInput } from '@xing-com/crate-common-graphql-types';
import { getXingJobsDirectorySkillSkillPath } from '@xing-com/crate-core-routes';
import { SeoLinkBoxesDocument } from '@xing-com/crate-jobs-domain-serps-graphql';

type LocationsBySkillParams = {
  jobRole: string;
  queryKey?: number;
};

export const useGetPopularSkills = ({
  jobRole,
  queryKey,
}: LocationsBySkillParams): {
  collection: {
    displayName: string;
    url: string;
    moreUrl: string;
  }[];
} => {
  const variables: SeoLinkBoxInput = {
    jobRole,
    serpType: 'jobRole',
  };
  const { data } = useSuspenseQuery(SeoLinkBoxesDocument, {
    queryKey,
    variables,
  });
  const popularLocations = data?.seoLinkBoxes?.collection.find(
    (item) => item?.kind === 'job_role_related_skills'
  );
  const collection = popularLocations
    ? popularLocations.entries.map((entry) => ({
        displayName: entry?.name || '',
        url: entry?.url || '',
        moreUrl: getXingJobsDirectorySkillSkillPath({
          skill: entry?.name || '',
        }).toLocaleLowerCase(),
      }))
    : [];

  return { collection };
};
